<template>

  <div class="atividades-lavadorlancamentos ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="6">
                <label for="select-garagem">Garagem</label> 
                <multiselect  v-model="value_garagem" required 
                  :options="garagens" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" name="garagem"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                   <label for="select-status">Status Lavador</label>  

                <multiselect id="selecaostatus" v-model="value_status"  required
                :options="statuss" 
                :multiple="true"                 
                :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true" placeholder="Status" label="status" track-by="status" name="status"
                :preselect-first="true">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

              <b-col cols="2">
                <br>                 
                <b-button variant="primary" class="mt-2 mp-2" :disabled="carregando" @click="carregando = true,loadLavagemLancamentos()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>

              <b-col>
                <div >       
                <b-progress class="mt-3 mp-3" :max="barra_limite">
                  <b-progress-bar variant="success"  :value="barra_inicial" :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"></b-progress-bar>
                </b-progress>
                </div>
              </b-col>

          </b-row>
    </b-form>
    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="lavagemlancamentos"  small hover striped sticky-header="550px"  :items="lavagemlancamentos" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregaLavagem(data.item)"    title="Acessar RFI"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1" cancel-title="Fechar" ok-title="Gravar" @ok="postLavagem(),reset() " size="xl" title="FROTA NO LAVADOR.: " no-close-on-esc no-close-on-backdrop  >
          <!-- -->
          <div>

            <b-row>
              <input  id="id-carro" type="hidden" v-model="lavagemlancamento.id_carro" />
              
              <b-col cols="2">
                <label for="input-live">Carro</label> 
                <b-form-input id="carro" v-model="lavagemlancamento.carro" readonly   placeholder="Digite o Nº do carro"></b-form-input>                                              
              </b-col>


            </b-row>

            <b-row>


            <b-col sm="5">
              <label for="input-parecer">Tipo de Lavagem</label>
              <div>                    
                <b-form-select   id="parecer"               
                  v-model="lavagemlancamento.id_tipo_lavagem"  
                  :options="tplavagens"
                  class="mb-3"
                  text-field="lavagem"                            
                >                
                </b-form-select>
              </div>
            </b-col> 
              
            </b-row> 


            <b-row>
              <b-col sm="2">
                <label for="textarea-small">Observações:</label>
                
              </b-col>
              <b-col sm="12">
                <b-form-textarea                   
                  id="id-obs"
                  v-model="lavagemlancamento.obs_lavador"
                  size="sm"      
                  placeholder="Digite as observações"
                ></b-form-textarea>
              </b-col>
            </b-row> 
            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'


export default {    
    name: 'ManutencaoLavadorLancamento',    

    data: function() {
      
        return {            
            mode: 'save',
            carregando: false,
            atualizando: false,            
            garagem:{}, 
            garagens: [],   // [] lista            
            value_garagem:[],// [] lista     
            
            status:{},
            statuss: [],   // [] lista            
            value_status:[],// [] lista    

            tplavagem:{},// [] lista    
            tplavagens:[],// [] lista    
            value_tplavagem:[],  
                    
            statusinc:{},
            statussinc: [],   // [] lista
            value_statusinc: [],            
                                     
            rfilancamento:{},// [] lista   
            rfilancamentos:[],// [] lista
            
            value_carro:'',
            value_motivo: '',
            value_pecas:'',
            value_observacoes:'',
            
            barra_inicial: 0,                     
            barra_limite: 30000,
            
            fields: [
                { key: 'id', label: 'Nº RFI', sortable: true },     
                { key: 'id_filial', label: 'Garagem', sortable: true },                 
                { key: 'carro', label: 'Carro', sortable: true },                
                
                
                { key: 'lavador_status', label: 'Status', sortable: true },                
                { key: 'lavagem', label: 'Tipo Lavagem', sortable: true },

                { key: 'dt_liberacao', label: 'Liberado do RFI', sortable: true, formatter: (value, key, lavagemlancamentos) => {
                    return moment(lavagemlancamentos.dt_liberacao).format('DD/MM/YYYY - HH:mm:ss').replace('Data inválida','-') ; }  },

                { key: 'lavador_liberado', label: 'Liberado do lavador', sortable: true, formatter: (value, key, lavagemlancamentos) => {
                    return moment(lavagemlancamentos.lavador_liberado).format('DD/MM/YYYY - HH:mm:ss').replace('Data inválida','-') ; }  },


                { key: 'obs_lavador', label: 'Observações', sortable: true },                               
                
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {

      showModalLancamento() {
        this.$refs['v-b-modal.modal-multi-1'].show()
      },

      //barra de progresso
      ready () {
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          this.loadLavagemLancamentos()
        }
      },1000)
      },

        loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`
          axios.get(url).then(res => {
            this.garagens = res.data.map(garagem => {              
              return { id_filial: garagem.id_filial, garagem: garagem.garagem }
            })
          })
        },        

        //////////////// 16/09/2022 14:hs - migração gudma para ML18
        loadStatus() {
          const url = `${baseApiUrl}/manutencao/lavador/lancamentos/getLavadorStatus`
          axios.get(url).then(res => {
            this.statuss = res.data.map(stslavador => {              
              return { id_status: stslavador.id_status, status: stslavador.status }
            })
          })
        },


        loadTipoLavagem() {
          const url = `${baseApiUrl}/manutencao/lavador/lancamentos/getLavadorTipoLavagem`
          axios.get(url).then(res => {
            this.tplavagens = res.data.map(tpl => {              
               return { ... tpl, value: tpl.id_tipo_lavagem, motivo: tpl.motivo }
            })
          })
        },


        loadCarros() {          
          const url = `${baseApiUrl}/despachante/carro/${this.lavagemlancamento.carro}`
          axios.get(url).then(res => { this.lavagemlancamento = res.data })          
        },        

        loadLavagemLancamentos() {                        
            let corpo = {    
                "id_filial": `${[this.value_garagem.map(a => a.id_filial)]}`,                
                "id_lavador_status": `${[this.value_status.map(sts => sts.id_status)]}`                
            };
 
            const url = `${baseApiUrl}/manutencao/lavador/lancamentos/getLavadorLancamentos`            
            axios.post(url,corpo)
                 .then(res => {                                
                this.carregando = false;
                this.lavagemlancamentos = res.data.map(lavagemlancamento => {
                            return {                              
                              id: lavagemlancamento.id, 
                              id_filial: lavagemlancamento.id_filial, 
                              id_carro: lavagemlancamento.id_carro,
                              carro: lavagemlancamento.carro,
                              dt_liberacao: lavagemlancamento.dt_liberacao, 
                              lavador_liberado: lavagemlancamento.lavador_liberado, 
                              obs_lavador: lavagemlancamento.obs_lavador,                               
                              id_lavador_status: lavagemlancamento.id_lavador_status,
                              lavador_status: lavagemlancamento.lavador_status,
                              lavador_liberou: lavagemlancamento.lavador_liberou,
                              lavador: lavagemlancamento.lavador,         
                              id_tipo_lavagem: lavagemlancamento.id_tipo_lavagem, 
                              lavagem: lavagemlancamento.lavagem, 
                              
                              
                            }              
                                                })
                        })            
        }, 
        loadCarregaLavagem(lavagemlancamento){
            this.lavagemlancamento = { ...lavagemlancamento }
        },

        
        
        postLavagem() {                        
        let corpo = { 
                "gdm_carro_manutencao_id": `${this.lavagemlancamento.id}`,                
                "obs_lavador": `${this.lavagemlancamento.obs_lavador}`,
                "id_tipo_lavagem": `${this.lavagemlancamento.id_tipo_lavagem}`,                                                                  
                
        };

        const url = `${baseApiUrl}/manutencao/lavador/lancamentos/savelavador`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },

        reset() {            
            this.lavagemlancamento = {}
            this.loadLavagemLancamentos()
            //this.value_carro = ''            
        }
       
    },



    mounted() {        
        this.loadGaragens()  
        this.loadTipoLavagem()
        this.loadStatus()              
        this.loadLavagemLancamentos()
        this.loadCarregaLavagem()        
        this.loadCarros()  
        this.ready()       
    },

}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>